import styled from '@emotion/styled'

import { theme } from '../../constants'
import { Button } from '../Button'
import { Flex } from '../Flex'

export const RangeUIWrapper = styled(Flex)(() => ({
  border: theme.border.style.thin,
  borderRadius: theme.border.radius.normal,
  overflow: 'hidden',
  boxShadow: theme.boxShadow.normal,
}))

export const RangeUIButton = styled(Button)({
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
})
